import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 24
}

/**
 * Stateless function representing a fuel pump icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <FuelPumpIcon width={12} />
 */
const FuelPumpIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M19.05 6.89603L12.54 9.46603C13.4683 10.3831 14.0002 11.6274 14.0217 12.9321C14.0433 14.2368
            13.5527 15.498 12.6552 16.4452C11.7577 17.3924 10.5248 17.9502 9.22084 17.9989C7.91688 18.0477 6.64574
            17.5835 5.68001 16.706L4.93001 18.966C4.82849 19.2646 4.63657 19.5242 4.38087 19.7087C4.12516 19.8933
            3.81835 19.9937 3.50301 19.996C3.34267 19.9996 3.18314 19.9724 3.03301 19.916C2.84571 19.8539 2.67252
            19.7554 2.52336 19.6262C2.37419 19.497 2.25198 19.3397 2.16373 19.1632C2.07548 18.9867 2.02292 18.7945
            2.00907 18.5976C1.99522 18.4008 2.02034 18.2032 2.08301 18.016L4.28301 11.406C4.51935 10.699 4.9117
            10.0542 5.431 9.51928C5.9503 8.9844 6.58326 8.57317 7.28301 8.31603L17.95 4.09603C18.3202 3.95093
            18.7326 3.95777 19.0977 4.11506C19.4629 4.27235 19.7512 4.56737 19.9 4.93603C20.0444 5.30888 20.0361
            5.72357 19.877 6.09039C19.718 6.4572 19.4209 6.74662 19.05 6.89603ZM9.00301 10.996C8.60744 10.996
            8.22076 11.1133 7.89187 11.3331C7.56297 11.5529 7.30662 11.8652 7.15525 12.2307C7.00387 12.5961
            6.96427 12.9983 7.04144 13.3862C7.11861 13.7742 7.30909 14.1305 7.58879 14.4102C7.8685 14.6899
            8.22486 14.8804 8.61283 14.9576C9.00079 15.0348 9.40292 14.9952 9.76837 14.8438C10.1338 14.6924
            10.4462 14.4361 10.6659 14.1072C10.8857 13.7783 11.003 13.3916 11.003 12.996C11.0014 12.4661 10.7902
            11.9583 10.4155 11.5836C10.0407 11.2088 9.53295 10.9976 9.00301 10.996ZM19.503 9.99603C19.503 9.99603
            17.003 13.34 17.003 14.996C16.9425 15.7241 17.1708 16.4469 17.6385 17.0081C18.1062 17.5694 18.7759
            17.9242 19.503 17.996C20.2301 17.9242 20.8998 17.5694 21.3675 17.0081C21.8353 16.4469 22.0635 15.7241
            22.003 14.996C22.003 13.34 19.503 9.99603 19.503 9.99603Z`}
        />
    </SvgIcon>
)

FuelPumpIcon.defaultProps = defaultProps

export { FuelPumpIcon }
